import { render, staticRenderFns } from "./InlineMenu.vue?vue&type=template&id=e0447496&"
import script from "./InlineMenu.vue?vue&type=script&lang=ts&"
export * from "./InlineMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports